import { render, staticRenderFns } from "./Advisor.vue?vue&type=template&id=38a9a426&scoped=true&"
import script from "./Advisor.vue?vue&type=script&lang=js&"
export * from "./Advisor.vue?vue&type=script&lang=js&"
import style0 from "./Advisor.vue?vue&type=style&index=0&id=38a9a426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9a426",
  null
  
)

export default component.exports